import styled from 'styled-components';
import { DataGrid } from '../../../../ui-toolkit';

export const StyledDisbursedContainer = styled(DataGrid)`
  td {
    border: 1px solid ${(props) => props.theme.colors.lightGray} !important;
    overflow: hidden;
    word-break: break-all;
  }

  thead tr {
    div {
      display: block;
      height: max-content !important;
    }
    th {
      white-space: pre-line;
      border: 1px solid ${(props) => props.theme.colors.lightGray} !important;
      border-bottom: 3px solid ${(props) => props.theme.colors.lightGray} !important;
    }
  }
`;
